import { getItems } from './getItems';
import type ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import { trace } from 'owa-trace';

export default async function getItemFromIMId(internetMessageId: string): Promise<string> {
    if (!internetMessageId) {
        return '';
    }
    const itemShape = itemResponseShape({
        BaseShape: 'IdOnly',
    });

    try {
        const itemOrError = await getItems(
            [],
            itemShape,
            undefined /*shapeName*/,
            internetMessageId
        ).then(items => items?.[0] as ItemInfoResponseMessage);

        if (itemOrError && !(itemOrError instanceof Error)) {
            let id = itemOrError?.Items[0]?.ItemId?.Id || '';
            return id;
        }
        // Throw if itemOrError is an instance of Error or any other unexpected condition
        throw itemOrError;
    } catch (error) {
        trace.warn(`[getItemIdFromInternetMessageId] Couldn't fetch item id from IMId : ${error}`);
    }

    return '';
}
